package ai.wagemix.net.client

import ai.wagemix.net.models.WMAuthActionToken
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/password-resets/verify`: the account a reset link resets, without using the link. */
class WMVerifyPasswordResetRequestBuilder: FSRequestBuilder<WMVerifyPasswordResetRequestBuilder, WMAuthActionToken>() {

    override fun build(): FSRequest<WMAuthActionToken> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "password-resets", "verify")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMVerifyPasswordResetRequestBuilder = this
}
